import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import getinvoiceaction from "../../context/action/buy/getinvoiceaction";
import Buyinvoicedetailmodal from "./buyinvoicedetailmodal";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";

const Buyinvoice = () => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [company_id, setcompany_id] = useState("");
  const [from, setfrom] = useState("");
  const [to, setto] = useState("");
  const [barcode, setbarcode] = useState("");

  const [show, setshow] = useState(false);
  const [company_invoice_id, setcompany_invoice_id] = useState();
  const [items, setitems] = useState([]);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Modal */}
      <Buyinvoicedetailmodal
        show={show}
        setshow={setshow}
        company_invoice_id={company_invoice_id}
        items={items}
        setitems={setitems}
      />

      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">لیستی وەسڵی کاڵای کڕاو</h1>
          <p className="text-sm text-slate-400 mt-0.5">گەڕان و دیتنی وەسڵەکان</p>
        </div>
      </div>

      {/* Filter Section */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
        <div className="w-full">
          <label
            htmlFor="cate"
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
          >
            کۆمپانیا
          </label>
          <select
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            value={company_id}
            onChange={(val) => setcompany_id(val.target.value)}
          >
            <option value="">کۆمپانیا هەڵبژێرە</option>
            {initState.company.map((lis) => (
              <option key={lis.company_id} value={lis.company_id}>
                {lis.company_name}
              </option>
            ))}
          </select>
        </div>

        <div className="w-full">
          <label
            className={
              error?
              "block text-sm font-medium text-red-500 mb-1 text-right":
              "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            لە بەرواری
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            type="date"
            value={from}
            onChange={(val) => setfrom(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>

        <div className="w-full">
          <label
            className={
              error1?
              "block text-sm font-medium text-red-500 mb-1 text-right":
              "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            بۆ بەرواری
          </label>
          <input
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            type="date"
            value={to}
            onChange={(val) => setto(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>

        <div className="w-full">
          <label
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
          >
            باڕکۆد
          </label>
          <input
            type="text"
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            onClick={(val)=>{val.target.select()}}
            value={barcode}
            onChange={(val) => setbarcode(val.target.value)}
          />
        </div>

        {/* Search Button */}
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (from == "" || !from) {
                seterror(true);
                return false;
              }
              if (to == "" || !to) {
                seterror1(true);
                return false;
              }
              getinvoiceaction(from, to, barcode, company_id)(recaller)(setrecaller)(
                initDispatch
              )(clear);
            }}
          >
            گەڕان
          </button>
        </div>
      </div>
      </div>

      {/* Invoices Table */}
      {initState.company_invoice_item.length > 0 && (
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
              <h2 className="text-base font-semibold text-slate-800">وەسڵی کڕاو</h2>
            </div>

            {/* Table */}
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆمپانیا
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    جۆری وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    ژمارەی وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    بەروار
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    نرخی وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    تێبینی
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {initState.company_invoice_item.map((lis, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      console.log(lis);
                      
                      setcompany_invoice_id(lis.company_invoice_id);
                      setitems(lis.items);
                      setshow(true);
                    }}
                    className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                  >
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_name}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_invoice_type == "loan" ? "قەرز" : "کاش"}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_invoice_number}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_invoice_date}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(
                          iqd_rounding(
                            lis.items.reduce(
                              (a, v) => (a = Number(a) + Number(v.company_invoice_item_price) * Number(v.company_invoice_item_qty)),
                              0
                            )
                          )
                        )}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.company_invoice_note}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
      )}
    </div>
  );
};

export default Buyinvoice;
